import { ReactNode } from 'react';
import {
  MdOutlineBusiness,
  MdOutlineCampaign,
  MdOutlineCorporateFare,
  MdOutlineLocalHospital,
  MdOutlineFlight,
  MdOutlinePages,
  MdOutlinePeopleAlt,
  MdOutlineGroups,
  MdOutlineSettings,
  MdOutlineMap,
} from 'react-icons/md';

type AdminMenuItem =
  | {
      type: 'section';
      open: boolean;
      hasPermission: boolean;
      children: {
        type: string;
        to: string;
        label: string;
        hasPermission: boolean;
      }[];
    }
  | {
      type: 'link';
      hasPermission: boolean;
    };

export type AdminMenuType = ({
  label: string;
  link: string;
  icon: ReactNode;
} & AdminMenuItem)[];

export const ADMIN_MENU: AdminMenuType = [
  {
    type: 'section',
    label: 'TMDX Users',
    link: '/admin/users',
    open: true,
    hasPermission: true,
    icon: <MdOutlinePeopleAlt size={24} />,
    children: [
      {
        type: 'link',
        to: '/employees',
        label: 'Employees',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/contractors',
        label: 'Contractors',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'section',
    label: 'Transplant Centers',
    link: '/admin/customers',
    open: true,
    hasPermission: true,
    icon: <MdOutlineGroups size={24} />,
    children: [
      {
        type: 'link',
        to: '/tx_centers',
        label: 'TX Centers',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/tx_users',
        label: 'TX Users',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'section',
    label: 'OPOs',
    link: '/admin/opos',
    open: true,
    hasPermission: true,
    icon: <MdOutlineCorporateFare size={24} />,
    children: [
      {
        type: 'link',
        to: '/locations',
        label: 'OPO Locations',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/contacts',
        label: 'OPO Contacts',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'section',
    label: 'Donor Hospitals',
    link: '/admin/hospitals',
    open: true,
    hasPermission: true,
    icon: <MdOutlineLocalHospital size={24} />,
    children: [
      {
        type: 'link',
        to: '/locations',
        label: 'Donor Hospital Locations',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/contacts',
        label: 'Donor Hospital Contacts',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'section',
    label: 'Devices',
    link: '/admin/devices',
    open: true,
    hasPermission: true,
    icon: <MdOutlinePages size={24} />,
    children: [
      {
        type: 'link',
        to: '/ocs_consoles',
        label: 'OCS Consoles',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/ocs_perfusion_sets',
        label: 'OCS Perfusion Sets',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'link',
    label: 'NOP Hubs',
    link: '/admin/hubs',
    hasPermission: true,
    icon: <MdOutlineBusiness size={24} />,
  },
  {
    type: 'link',
    label: 'Regions',
    link: '/admin/regions',
    hasPermission: true,
    icon: <MdOutlineMap size={24} />,
  },
  {
    type: 'section',
    label: 'Logistics providers',
    link: '/admin/logistics_providers',
    open: true,
    hasPermission: true,
    icon: <MdOutlineFlight size={24} />,
    children: [
      {
        type: 'link',
        to: '/supplemental_lift',
        label: 'Supplemental Lift Providers',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/tx_center',
        label: 'TX Center Providers',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'section',
    label: 'Configuration',
    link: '/admin/configuration',
    open: true,
    hasPermission: true,
    icon: <MdOutlineSettings size={24} />,
    children: [
      {
        type: 'link',
        to: '/tail_number_assignment',
        label: 'Tail Number Assignment',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/banned_tail_numbers',
        label: 'Banned Tail Numbers',
        hasPermission: true,
      },
      {
        type: 'link',
        to: '/banned_drivers',
        label: 'Banned Drivers',
        hasPermission: true,
      },
    ],
  },
  {
    type: 'link',
    label: 'Release Notes',
    link: '/admin/release-notes',
    hasPermission: true,
    icon: <MdOutlineCampaign size={24} />,
  },
];
